module.exports = __webpack_public_path__ + "static/media/Welcome-Step-1-B2C---V_4.15c118d9.png";